export default __webpack_public_path__ + "static/media/UTENTEonboarding04.cce6d39e.png";